import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './translations.action';

@Injectable({ providedIn: 'root' })
export class TranslationsTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                language_name: '', 
                access: null, 
                locale: null, //Null for select list
                translated: '', 
            };


    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'language_name';
    initialSortDirection = 'asc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    accesses = [];
    locales = [];
    hasFilter = false;
    columns = [
                { prop: 'language_name', name: 'TRANSLATION.language-name', sortable: true, hasFilter: true, filter: "input"},

                { prop: 'access', name: 'TRANSLATION.access', sortable: true, hasFilter: true, filter: "select", options: 'accesses', options_id: "id", options_label: "name" },

                { prop: 'locale', name: 'TRANSLATION.locale', sortable: true, hasFilter: true, filter: "select", options: 'locales', options_id: "name", options_label: "name" },

                { prop: 'translated', name: 'TRANSLATION.translated', sortable: true, hasFilter: false, filter: "number"},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            language_name: '', 
            access: null, 
            locale: null, 
            translated: '', 
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}